<template>
    <div class="pagination-wrap">
        <span class="prev" @click="pageNo>1?change(pageNo-1):()=>{}">上一页</span>

        <span v-for="(item,index) in paginationArr" :key="index" :class="{active:item == pageNo}" @click="change(item)">
            {{item}}
        </span>

        <span class="next" @click="pageNo<Math.ceil(total/pageSize)?change(pageNo+1):()=>{}">下一页</span>
        <div style="display: flex;justify-content: center;align-items: center">共 {{Math.ceil(total/pageSize)}} 页数据</div>
    </div>
</template>
<script>
    export default {
        name: "Pagination",
        props: {
            total: [Number],
            pageNo: [Number],
            pageSize: [Number],
            count: [Number]
        },
        data() {
            return {}
        },
        computed: {
            paginationArr: function () {
                let start=1;
                let pageCount = this.count;
                if (Math.ceil(this.total / this.pageSize) < pageCount) {
                    let list = []
                    let i = 0
                    while (i < Math.ceil(this.total / this.pageSize)) {
                        list.push(start++);
                        i++;
                    }
                    return list
                } else {
                    if (this.pageNo <= parseInt(pageCount / 2)) {
                        start = 1
                    }
                    if (this.pageNo > parseInt(pageCount / 2) && this.pageNo <= parseInt(this.total / this.pageSize) - parseInt(pageCount / 2)) {
                        start = this.pageNo - parseInt(pageCount / 2)
                    }
                    if (this.pageNo > parseInt(this.total / this.pageSize) - parseInt(pageCount / 2)) {
                        start = parseInt(this.total / this.pageSize) - pageCount + 1
                    }
                    let list = []
                    let i = 0
                    while (i <= pageCount) {
                        list.push(start++);
                        i++;
                    }
                    return list
                }

            }
        },
        methods: {
            change(item) {
                this.$emit('changePageNo', item)
            }
        }

    }
</script>

<style scoped lang="scss">
    .pagination-wrap {
        $rem: 0.01rem;
        display: flex;

        > span {
            border: 1*$rem solid #25FCFF;
            width: 40*$rem;
            height: 36*$rem;
            display: flex;
            justify-content: center;
            align-items: center;
            background: #344D76;
            margin-right: 6*$rem;
            box-sizing: border-box;
            cursor: pointer;
            transition: all 0.6s linear;

            &.active {
                transition: all 0.6s linear;
                background: #FF8700;
            }

            &:hover {
                background: #a35700;
            }

            &.prev, &.next {
                width: 80*$rem;
                height: 36*$rem;
            }
        }
    }
</style>
